import React, { useEffect, Suspense, useState, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { _numbering } from '../function/functions';
import { Img } from 'react-suspense-img';
import loading from '../assets/img_load.json';
import axios from 'axios';
import NftDetailModal from './detailModal/NftGalleryModal';
import detailItem from '../assets/goDetail.png';
import ShillaDetailModal from './detailModal/ShillaWalletModal';
import MysteryDetail from './detailModal/MysteryGalleryDetail';
import MembershipGalleyModal from './detailModal/MembertShipGalleryModal';
import ProductPackage from './detailModal/ProductGalleryModal';
import ShillaGalleryDetail from './detailModal/ShillaGalleryModal';
import { isMobile } from 'react-device-detect';
import { useRecoilState } from 'recoil';
import { translatedText } from '../recoil-states/language-state';

export default function ListItem({
	itemData,
	language,
	img_text,
	category,
	text,
}) {
	const [openDetailModal, setOpenDetailModal] = useState(false);
	const [hoverItem, setHoverItem] = useState(false);
	const [openShiModal, setOpenShiModal] = useState(false);
	const [openMystery, setOpenMystery] = useState(false);
	const [openCardModal, setOpenCardModal] = useState(false);
	const [mysteryModal, setMysteryModal] = useState(false);

	const openDetailData = () => {
		if (category === 'DUMAN') {
			setOpenDetailModal(true);
		} else if (category === 'Konnect Product Card') {
			setOpenMystery(true);
		} else if (itemData.description === 'Konnect SHILLA VIP MEMBERSHIP') {
			setOpenShiModal(true);
		} else if (itemData.type === 'membership_card') {
			setOpenCardModal(true);
		} else if (category === 'Mystery Box') {
			setMysteryModal(true);
		}
	};

	// function _numbering(number) {
	//     if (number < 10) return `0${number}`
	//     else return number;
	// }

	// const imgOption = {
	//     alt: itemData.category,
	//     style: {
	//         width: itemData.category === 'Konnect Product Card'? '100%' : '100%',
	//         borderRadius : '10px',
	//         marginTop: itemData.category === 'Konnect Product Card'? '-14px' : '0'
	//     },
	//     className: "list_item_card"
	// }

	return (
		<>
			{openDetailModal ? (
				<NftDetailModal
					id={itemData.id}
					text={img_text}
					name={text}
					setOpenDetailModal={setOpenDetailModal}
				/>
			) : null}
			{openShiModal ? (
				<ShillaGalleryDetail
					itemData={itemData}
					setOpenShiModal={setOpenShiModal}
					view={false}
				/>
			) : null}
			{openMystery ? (
				<ProductPackage
					itemData={itemData}
					setOpenMystery={setOpenMystery}
					view={false}
				/>
			) : null}
			{openCardModal ? (
				<MembershipGalleyModal
					itemData={itemData}
					setOpenCardModal={setOpenCardModal}
					view={false}
				/>
			) : null}
			{mysteryModal ? (
				<MysteryDetail
					itemData={itemData}
					setMysteryModal={setMysteryModal}
					view={false}
				/>
			) : null}
			<Container
				className='list_item'
				onClick={() => {
					openDetailData();
				}}
				style={{ cursor: 'pointer' }}
				onMouseOver={() => {
					return !isMobile ? setHoverItem(true) : null;
				}}
				onMouseLeave={() => setHoverItem(false)}
			>
				<ImageContainer>
					<img
						src={
							category === 'DUMAN' ||
							itemData.type === 'membership_card' ||
							itemData.type === 'product_card'
								? category === 'DUMAN'
									? process.env.PUBLIC_URL +
									  `assets/${img_text}/${itemData.id}.webp`
									: // ? require(`../assets/${img_text}/${itemData.id}.webp`)
									  require(`../assets/${itemData.type}/${itemData.image}.png`)
								: category === 'Mystery Box'
								? require(`../assets/mysteryBox.png`)
								: `${process.env.REACT_APP_BACKEND_API}/assets/${itemData.image}`
						}
						alt={itemData.category}
						style={{
							width:
								itemData.category === 'Konnect Product Card'
									? '100%'
									: '100%',
							borderRadius: '10px',
							marginTop:
								itemData.category === 'Konnect Product Card'
									? '-14px'
									: '0',
						}}
						className='list_item_card'
					/>
				</ImageContainer>
				{category === 'DUMAN' ? (
					<TextContainer>
						<LeftTextContainer>
							<CategoryText>
								{category === 'DUMAN'
									? `Duman : ${text}`
									: `${itemData.name}`}
							</CategoryText>
						</LeftTextContainer>
						<RightTextContainer>
							<IdText>
								{category === 'DUMAN'
									? `#${itemData.id}`
									: null}
							</IdText>
						</RightTextContainer>
					</TextContainer>
				) : null}
				<HoverBox
					style={{ opacity: hoverItem ? '1' : '0' }}
				>
					<img src={detailItem} />
				</HoverBox>
			</Container>
		</>
	);
}

const Container = styled.div`
	min-width: 200px;
	min-height: 232px;
	background-color: var(--sub-bg-color);
	border-radius: 10px;
	position: relative;
`;

const ImageContainer = styled.div``;

const TextContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;

	@media screen and (max-width: 300px) {
		padding: 10px;
		padding-top: 5px;
	}
`;

const LeftTextContainer = styled.span``;

const CategoryText = styled.span`
	font-size: 17px;
	font-family: 'NotoSansMd';

	@media screen and (max-width: 300px) {
		font-size: 15px;
	}
`;

const TypeText = styled.span`
	font-family: 'Noto Sans ExtraLight';

	@media screen and (max-width: 300px) {
		font-size: 13px;
	}
`;

const RightTextContainer = styled.div``;

const IdText = styled.span`
	font-size: 17px;
	font-family: 'NotoSansMd';

	@media screen and (max-width: 300px) {
		font-size: 13px;
	}
`;

const HoverBox = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0%;
	background-color: rgba(0, 0, 0, 0.7);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.3s ease-in-out;
	/* opacity: 0; */
`;
